
  import {
    eventStates,
    eventTypes,
    getEventTypesByProjectType,
    getRequestTypesByProjectType,
    getTimelineItemIcon
  } from "../../../_helpers/eventTypesStates";
  import { projectTypes } from "../../../_helpers/projectMetadata";
  import {
    getExtensionIcon,
    servicesExtensions
  } from "../../../_helpers/servicesExtensions";
  import RequestForm from "../../../components/services/deliveryexperience/request/RequestForm.vue";
  import ProjectCore from "../../../models/core/ProjectCore";
  import { IBaseLineDx } from "../../../models/deliveryexperience/BaseLineDx";
  import EventDx from "../../../models/deliveryexperience/EventDx";
  import ReadWrite from "../../../models/deliveryexperience/Permissions/ReadWrite";
  import RequestDx from "../../../models/deliveryexperience/RequestDx";
  import StageDx from "../../../models/deliveryexperience/StageDx";
  import SingleSelectType from "../../../view-models/SingleSelectType";
  import CapsuleLabelInput from "../../view_elements/CapsuleLabelInput.vue";
  import FilterDropdown from "../../view_elements/FilterDropdown.vue";
  import PeoplePermissions from "./people/PeoplePermissions.vue";
  import TimelineCarousel from "./timeline/TimelineCarousel.vue";
  import TimelineChart from "./timeline/TimelineChart.vue";
  import TimelineItemForm from "./timeline/TimelineItemForm.vue";

  export default {
    name: "Timeline",
    components: {
      TimelineChart,
      TimelineCarousel,
      TimelineItemForm,
      RequestForm,
      PeoplePermissions,
      FilterDropdown,
      CapsuleLabelInput
    },
    props: {
      projectId: Number,
      projectCore: ProjectCore,
      eventsDx: Array<EventDx>,
      stagesDx: Array<StageDx>,
      requestsDx: Array<RequestDx>
    },
    data() {
      return {
        itemNameFilter: "",
        showSearchFilter: false,
        currentDate: new Date(),
        showChart: true,
        monthsNum: 3,
        showStages: true,
        showToday: false,
        filterItems: [],
        filterTags: [],
        timelineItemIdAndType: { id: undefined, type: undefined },
        timelineItemFormId: "dx-timeline-item-form",
        requestFormId: "dx-request-form-from-timeline",
        timelineItemFormAction: "",
        timelineItemFormType: "",
        timelineItemFormItemId: undefined,
        showTooltip: false,
        filter: {
          events: true,
          stages: true,
          lifetime: true
        },
        monthOptions: [],
        months: new SingleSelectType({
          key: "3",
          name: this.$tc("monthsView", 2, { months: "3" })
        }),
        text: {
          searchElement: `${this.$t("search")} ${this.$tc("item", 1)}`,
          monthsView1: this.$tc("monthsView", 1, { months: "1" }),
          monthsView3: this.$tc("monthsView", 2, { months: "3" }),
          monthsView6: this.$tc("monthsView", 2, { months: "6" }),
          monthsView9: this.$tc("monthsView", 2, { months: "9" }),
          today: this.$t("today"),
          stage: this.$t("stages"),
          event: this.$t("events"),
          requests: this.$t("requests"),
          create: this.$t("create"),
          edit: this.$t("editRemove"),
          lifetime: this.$t("lifetime"),
          tags: this.$tc("tag", 2),
          filterTags: this.$t("filterTags"),
          all: this.$tc("all", 2),
          clear: this.$t("clear")
        },
        liabilityTemporaryString: projectTypes.liabilityTemporary.name,
        liabilityFullString: projectTypes.liabilityFull.name
      };
    },
    async created() {
      await this.setPendingToConfirmEventsStatus();
      await this.setPendingToConfirmStagesStatus();

      this.$root.$on("editTimelineItemForm", timelineItemFormData => {
        this.timelineItemFormType = timelineItemFormData.type;
        this.timelineItemFormAction = timelineItemFormData.action;
        this.timelineItemFormItemId = timelineItemFormData.itemId;
        this.$bvModal.show(
          this.timelineItemFormType === "request"
            ? this.requestFormId
            : this.timelineItemFormId
        );
      });

      // Calls from outer components to redirect to timeline and open an item
      this.$root.$on("goToTimelineItem", (id, type) =>
        this.goToTimelineItem(id, type)
      );

      const monthsView = ["1", "3", "6", "9"];
      for (const months of monthsView) {
        this.monthOptions.push(
          new SingleSelectType({
            key: months,
            name: this.text[`monthsView${months}`]
          })
        );
      }
      this.months = this.monthOptions[1];
    },
    computed: {
      showLifetime(): boolean {
        return true;
      },
      filteredProjectEventsDx(): EventDx[] {
        return this.eventsDx.filter(event => {
          if (
            this.filterItems.length &&
            !this.filterItems.includes(event.getEventType)
          ) {
            return false;
          } else if (
            this.itemNameFilter.length &&
            !event.getName.includes(this.itemNameFilter)
          ) {
            return false;
          } else if (
            !this.getUser.isSogeti() &&
            (event.getEventType ==
              eventTypes.PEOPLE.events.newIncorporation.type ||
              event.getEventType == eventTypes.PEOPLE.events.unassignment.type)
          ) {
            return false;
          } else return true;
        });
      },
      filteredProjectRequestsDx(): RequestDx[] {
        return this.requestsDx.filter(request => {
          if (
            this.filterItems.length &&
            !this.filterItems.includes(request.getType)
          ) {
            return false;
          } else if (
            this.itemNameFilter.length &&
            !request.getIssue.includes(this.itemNameFilter)
          ) {
            return false;
          } else return true;
        });
      },
      filteredProjectStagesDx(): StageDx[] {
        return this.stagesDx.filter(stage => {
          if (
            this.itemNameFilter.length &&
            !stage.getName.includes(this.itemNameFilter)
          ) {
            return false;
          } else return true;
        });
      },
      permissionsEvents(): ReadWrite {
        return this.getUserPermissions.events;
      },
      permissionsStages(): ReadWrite {
        return this.getUserPermissions.stages;
      },
      getExtensionIcon(): NodeRequire {
        return getExtensionIcon(
          servicesExtensions.deliveryExperience.extensions.timeline.name
        );
      },
      filterDropdownEvents(): any {
        return this.getEventTypesByProjectType(
          this.projectCore.getProjectType
        ).map(eventType => {
          return {
            value: eventType.type,
            html: this.getFilterDropdownHtmlContent(
              eventType.type,
              eventType.name,
              this.eventsDx.filter(e => e.getEventType == eventType.type).length
            )
          };
        });
      },
      filterDropdownRequests(): any {
        return this.getRequestTypesByProjectType(
          this.projectCore.getProjectType
        ).map(requestType => {
          return {
            value: requestType.type,
            html: this.getFilterDropdownHtmlContent(
              requestType.type,
              this.$tc(requestType.i18n, 1),
              this.requestsDx.filter(r => r.getType == requestType.type).length
            )
          };
        });
      },
      filterDropdownItems(): any {
        return this.filterDropdownEvents.concat(this.filterDropdownRequests);
      }
    },
    methods: {
      openTimelineItem(id) {
        // Find the element in the list
        const item = this.orderedTimelineChartItems.find(
          item =>
            item.id === id ||
            (item.items && item.items.some(subItem => subItem.id === id))
        );

        if (item) {
          // Move to the element in the timeline
          const element = document.getElementById(`timeline-item-${id}`);
          if (element) {
            element.scrollIntoView({ behavior: "smooth", block: "center" });
          }

          // Highlight the element
          this.getTimelineItemId = id;
        }
      },
      openSearchFilter() {
        this.showSearchFilter = true;
        let searchCapsule = <HTMLInputElement>(
          document.getElementById("input_search-elems-input")
        );

        this.$nextTick(() => searchCapsule.focus());
      },
      getTimelineItems() {
        return this.timelineItems || [];
      },
      searchElements(value) {
        this.itemNameFilter = value;
        if (
          this.filteredProjectEventsDx.length +
            this.filteredProjectRequestsDx.length +
            this.filteredProjectStagesDx.length ==
          1
        ) {
          if (this.filteredProjectEventsDx.length) {
            this.goToTimelineItem(
              this.filteredProjectEventsDx[0].getId,
              "event"
            );
          } else if (this.filteredProjectRequestsDx.length) {
            this.goToTimelineItem(
              this.filteredProjectRequestsDx[0].getId,
              "request"
            );
          } else if (this.filteredProjectStagesDx.length) {
            this.goToTimelineItem(
              this.filteredProjectStagesDx[0].getId,
              "stage"
            );
          }
        }
      },
      resetActionAndTypeValues(): void {
        this.timelineItemFormAction = undefined;
        this.timelineItemFormType = undefined;
        this.timelineItemFormItemId = undefined; // Reset it after an item may have been created
      },
      openTimelineItemForm: function (action: string, type: string) {
        this.timelineItemFormItemId = undefined; // Reset it after an item may have been created
        this.chargeTypePage(action, type);
      },
      chargeTypePage: function (action: string, type: string) {
        this.timelineItemFormAction = action;
        this.timelineItemFormType = type;
        this.$bvModal.show(this.timelineItemFormId);
      },
      changeMonthsView: function (months: Number) {
        this.monthsNum = months;
      },
      rerenderOverview(): void {
        this.$emit("rerenderOverview");
      },
      showFilterButton: function (filterType): boolean {
        return (
          filterType !== "lifetime" ||
          ((this.projectCore.getProjectType ===
            projectTypes.liabilityTemporary.name ||
            this.projectCore.getProjectType ===
              projectTypes.liabilityFull.name) &&
            this.showChart)
        );
      },
      showHideStages() {
        this.showStages = !this.showStages;
      },
      evalTextVariable(key): string {
        switch (key) {
          case "lifetime":
            return this.text.lifetime;
          case "events":
            return this.text.event + " / " + this.text.requests;
          default:
            return this.text.stage;
        }
      },
      getGroupItems(): string[] {
        let items = [];
        if (this.permissionsEvents.write) {
          items.push("event");
        }
        if (this.permissionsStages.write) {
          items.push("stage");
        }
        return items;
      },
      async loadPermissionsManagement() {
        this.$bvModal.show("permissions-management-modal-timeline");
      },
      getEventTypesByProjectType(projectType: string): any[] {
        return Object.values(getEventTypesByProjectType(projectType));
      },
      getRequestTypesByProjectType(projectType: string): {
        type: string;
        i18n: string;
        icon: string;
      }[] {
        return getRequestTypesByProjectType(projectType);
      },
      getFilterDropdownHtmlContent(type, text, count): string {
        return `
          <div class="d-flex justify-content-between">
            <div class="text-truncate">
              <img width="20" src='${getTimelineItemIcon(type)}'></img>
              <span class="ml-1">${text}</span>
            </div>
            <span class="ml-1">${count}</span>
          </div>
        `;
      },
      switchView(): void {
        this.showChart = !this.showChart;

        if (this.timelineItemIdAndType.id != undefined) {
          this.$nextTick(() =>
            this.goToTimelineItem(
              this.timelineItemIdAndType.id,
              this.timelineItemIdAndType.type
            )
          );
        }
      },
      filterByTags(selectedTags: []): void {
        this.filterTags = selectedTags;
      },
      filterByItems(selectedItems: []): void {
        this.filterItems = selectedItems;
      },
      scrollToToday() {
        if (this.showChart) this.$refs.timelineChart.showToday();
        else this.$refs.timelineCarousel.showToday();
      },
      goToTimelineItem(id: string, type: string): void {
        if (this.showChart) this.$refs.timelineChart.openTimelineItem(id, type);
        else this.$refs.timelineCarousel.selectItem(id, type);
      },
      async setPendingToConfirmEventsStatus(): Promise<void> {
        for (const event of this.eventsDx) {
          const eventId: string = event.getId;
          const baseline: IBaseLineDx = event.getBaseline;
          baseline.endDate = null; // Events don't have end date
          const eventStartDate: Date = new Date(baseline.startedDate);
          if (this.currentDate.getTime() > eventStartDate.getTime()) {
            if (baseline.status == eventStates.pendingToOccur.name) {
              if (
                [
                  eventTypes[projectTypes.capacity.name].events.reload.type,
                  eventTypes[projectTypes.capacity.name].events.billing.type,
                  eventTypes[projectTypes.capacity.name].events.consume.type,
                  eventTypes.PEOPLE.events.unassignment.type,
                  eventTypes.PEOPLE.events.newIncorporation.type
                ].includes(event.getEventType)
              ) {
                baseline.status = eventStates.occurred.name;
              } else {
                baseline.status = eventStates.pendingToConfirm.name;
              }

              try {
                await this.putEventDxBaseline({
                  baseline: baseline,
                  eventId: eventId
                });
              } catch (error) {
                this.$log.error(error);
              }
            }
          }
        }
      },
      async setPendingToConfirmStagesStatus(): Promise<void> {
        for (const stage of this.stagesDx) {
          const stageId: string = stage.getId;
          const baseline: IBaseLineDx = stage.getBaseline;
          const stageEndDate: Date = new Date(baseline.endDate);
          if (this.currentDate.getTime() > stageEndDate.getTime()) {
            if (baseline.status == eventStates.pendingToOccur.name) {
              baseline.status = eventStates.pendingToConfirm.name;
              try {
                await this.putStageDxBaseline({
                  baseline: baseline,
                  stageId: stageId
                });
              } catch (error) {
                this.$log.error(error);
              }
            }
          }
        }
      }
    },
    watch: {
      showTooltip() {
        this.$root.$emit("openTooltips", this.showTooltip, { root: true });
      },
      months() {
        this.changeMonthsView(parseInt(this.months.key));
      }
    }
  };
